import { stringify } from 'query-string'
import { fetchUtils } from 'react-admin'
import moment from 'moment'

const apiUrl = `${window.variables.urlSite}/wp-json/wp/v2`
const httpClient = fetchUtils.fetchJson

const postsProvider = {
  getList: async (ressource, params) => {
    const { page, perPage } = params.pagination
    const { field, order } = params.sort
    const { filter } = params

    const query = {
      per_page: perPage,
      page,
      orderby: field,
      order: order.toLowerCase(),
      ...filter
    }

    const res = await httpClient(`${apiUrl}/${ressource}?${stringify(query)}`)
    const { headers, json } = res
    return {
      data: json,
      total: +headers.get('X-WP-Total')
    }
  },
  getMany: async (post, params) => {
    const { ids } = params
    const query = {
      include: ids
    }
    const url = `${apiUrl}/${post}?${stringify(query)}`
    const res = await httpClient(url)
    const { json } = res
    return { data: json }
  },
  getOne: async (ressource, params) => {
    const { id } = params

    const res = await httpClient(`${apiUrl}/${ressource}/${id}`)
    const { json } = res
    return {
      data: json
    }
  },
  update: async (ressource, params) => {
    const { id, slug, status, title, post_metas } = params.data

    const myHeaders = new Headers()
    myHeaders.append('X-WP-Nonce', window.variables.nonce)
    myHeaders.append('Content-Type', 'application/json')

    const raw = JSON.stringify({
      slug,
      status,
      title: title.rendered,
      // meta	Meta fields.
      post_metas
    })

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    }

    const res = await httpClient(`${apiUrl}/${ressource}/${id}`, requestOptions)
    const { json } = res

    return {
      data: json
    }
  },
  create: async (ressource, params) => {
    const { id, slug, status, title, post_metas, date } = params.data

    const myHeaders = new Headers()
    myHeaders.append('X-WP-Nonce', window.variables.nonce)
    myHeaders.append('Content-Type', 'application/json')

    const raw = JSON.stringify({
      status: 'publish',
      title: title?.rendered,
      post_metas,
      date: moment(date)

      // meta	Meta fields.
    })

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    }
    try {
      const res = await httpClient(`${apiUrl}/${ressource}`, requestOptions)
      const { json } = res
      return {
        data: json
      }
    } catch (e) {
      console.error('error delete', e)
    }
  },
  delete: async (ressource, params) => {
    const { id } = params

    const myHeaders = new Headers()
    myHeaders.append('X-WP-Nonce', window.variables.nonce)
    myHeaders.append('Content-Type', 'application/json')

    const requestOptions = {
      method: 'DELETE',
      headers: myHeaders,
      redirect: 'follow'
    }
    try {
      const res = await httpClient(
        `${apiUrl}/${ressource}/${id}`,
        requestOptions
      )
      const { json } = res
      return {
        data: json
      }
    } catch (e) {
      console.error('dsqfbqds', e)
    }
  },
  deleteMany: async (ressource, params) => {
    const { ids } = params

    const myHeaders = new Headers()
    myHeaders.append('X-WP-Nonce', window.variables.nonce)
    myHeaders.append('Content-Type', 'application/json')

    const requestOptions = {
      method: 'DELETE',
      headers: myHeaders,
      redirect: 'follow'
    }

    const data = await ids.filter(async (id) => {
      try {
        const res = await httpClient(
          `${apiUrl}/${ressource}/${id}`,
          requestOptions
        )
        const { json } = res
        if (json.id === id) {
          return true
        }
        return false
      } catch (e) {
        console.error(`error delete ${id}`, e)
        return false
      }
    })

    return {
      data
    }
  }
}
// create: async (post, params) => {
//   console.log('create', post, params)
//   return {
//     data: { id: 450, title: 'hello, world 450' }
//   }
// },
// update: async (post, params) => ({
//   data: { id: 123, title: 'New hello, world!' }
// }),
// delete: async (post, params) => ({
//   id: 123
// })

// dataProvider
//   .getMany('posts', { ids: [123, 124, 125] })
//   .then((response) => console.log(response))
// {
//     data: [
//         { id: 123, title: "hello, world" },
//         { id: 124, title: "good day sunshise" },
//         { id: 125, title: "howdy partner" },
//     ]
// }

// dataProvider
//   .getManyReference('comments', {
//     target: 'post_id',
//     id: 123,
//     sort: { field: 'created_at', order: 'DESC' }
//   })
//   .then((response) => console.log(response))

// // {
// //     data: [
// //         { id: 667, title: "I agree", post_id: 123 },
// //         { id: 895, title: "I don't agree", post_id: 123 },
// //     ],
// //     total: 2,
// // }

// dataProvider
//   .create('posts', { data: { title: 'hello, world' } })
//   .then((response) => console.log(response))
// // {
// //     data: { id: 450, title: "hello, world" }
// // }

// dataProvider
//   .update('posts', {
//     id: 123,
//     data: { title: 'hello, world!' },
//     previousData: { title: 'previous title' }
//   })
//   .then((response) => console.log(response))
// // {
// //     data: { id: 123, title: "hello, world!" }
// // }

// dataProvider
//   .updateMany('posts', {
//     ids: [123, 234],
//     data: { views: 0 }
//   })
//   .then((response) => console.log(response))
// // {
// //     data: [123, 234]
// // }

// dataProvider
//   .delete('posts', {
//     id: 123,
//     previousData: { title: 'hello, world!' }
//   })
//   .then((response) => console.log(response))
// // {
// //     data: { id: 123, title: "hello, world" }
// // }

// dataProvider
//   .deleteMany('posts', { ids: [123, 234] })
//   .then((response) => console.log(response))
// // {
// //     data: [123, 234]
// // }
export default postsProvider
